import { Skeleton } from 'antd';
import { Column, Row } from 'farmhub-ui-core';

const InformationElectronicBillSkeleton = () => (
  <Row justifyContent="space-between">
    <Column
      alignItems="flex-start"
      styles={{
        gap: 18,
        flexWrap: 'wrap',
        borderLeft: '1px solid #efefef',
        paddingLeft: '18px',
      }}
      width="fit-content"
    >
      <>
        <Row styles={{ gap: 6, flexShrink: 0 }} width="fit-content">
          <Skeleton.Input size="small" style={{ width: 25, height: 25 }} />
          <Skeleton.Input size="small" style={{ width: 100 }} />
        </Row>

        <Row styles={{ gap: 6, flexShrink: 0 }} width="fit-content">
          <Skeleton.Input size="small" style={{ width: 25, height: 25 }} />
          <Skeleton.Input size="small" style={{ width: 100 }} />
        </Row>

        <Row styles={{ gap: 6, flexShrink: 0 }} width="fit-content">
          <Skeleton.Input size="small" style={{ width: 25, height: 25 }} />
          <Skeleton.Input size="small" style={{ width: 100 }} />
        </Row>
      </>
    </Column>
    <Column alignItems="center" styles={{ gap: 12 }} width="fit-content">
      <Skeleton.Input size="small" style={{ width: 96, height: 96 }} />
      <Skeleton.Input size="small" style={{ width: 96 }} />
    </Column>
  </Row>
);

export default InformationElectronicBillSkeleton;
